import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { passwordPairReady } from "../../components/neu/PasswordPair";
import { JoinFields } from "./JoinFields";
import { JoinConsents } from "./JoinConsents";
import { ReferenceCamera } from "./refcam/ReferenceCamera";

export const JoinForm = ({ invite, frames, setFrames, submit, busy, error }) => {
  const { t, i18n } = useTranslation();
  const [form, setForm] = useState({ name: "", password: "", confirm: "", phone: "" });
  const [scanOpen, setScanOpen] = useState(false);
  const [consents, setConsents] = useState({});

  const agreed = ["terms", "privacy", "eula", "biometric"].every((k) => consents[k]);
  const match = passwordPairReady(form.password, form.confirm);
  const onConfirm = (blob) => {
    const r = new FileReader();
    r.onload = () => { setFrames([r.result]); setScanOpen(false); };
    r.readAsDataURL(blob);
  };

  return (
    <NeuCard className="animate-rise-in" data-testid="join-form">
      <p className="label-xs">{t("join.step1")}</p>
      <p className="mt-2 text-sm text-muted-foreground">
        {t("join.company")}: <span className="font-semibold text-foreground">{invite.company_name}</span> ·{" "}
        {t("join.invitedAs")}: {t(`roles.${invite.role}`)} · {invite.email}
      </p>

      <JoinFields form={form} setForm={setForm} />

      <p className="label-xs mt-6">{t("join.step2")}</p>
      <JoinConsents value={consents} onChange={setConsents} />
      {!agreed ? (
        <p className="mt-2 text-xs font-bold text-destructive" data-testid="join-consent-required">
          {t("consent.requiredBeforeScan")}
        </p>
      ) : null}
      {frames.length ? (
        <p className="mt-3 text-center text-sm font-black text-primary" data-testid="join-face-captured">{t("join.captured")}</p>
      ) : null}
      <NeuButton className="mt-3 w-full py-3" data-testid="join-open-camera" disabled={!agreed} onClick={() => setScanOpen(true)}>
        {frames.length ? t("join.recapture") : t("join.startScan")}
      </NeuButton>
      {scanOpen ? (
        <ReferenceCamera
          lang={i18n.language === "en" ? "en" : "ar"}
          company={invite.company_name}
          role={t(`roles.${invite.role}`)}
          onClose={() => setScanOpen(false)}
          onConfirm={onConfirm}
        />
      ) : null}

      {error ? (
        <p className="mt-4 text-sm font-semibold text-destructive" data-testid="join-submit-error">
          {error}
        </p>
      ) : null}
      <NeuButton
        variant="primary"
        className="mt-5 w-full py-4"
        data-testid="join-submit"
        disabled={busy || form.name.trim().length < 3 || !match || frames.length < 1 || !agreed}
        onClick={() => submit({ name: form.name.trim(), password: form.password, phone: form.phone, language: i18n.language, consents })}
      >
        {t("join.submit")}
      </NeuButton>
    </NeuCard>
  );
};
